import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function EmojiFlagsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"emoji_flags"}/>
}
